import React, {useState, useEffect} from 'react'
import { AppWrap, MotionWrap } from '../../wrapper'
import './Footer.scss'
import { images } from '../../constants'
import { client } from '../../client'

const Footer = () => {
  const [formData, setFormData] = useState({name:'', email:'', message:''})
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
 
  const {name, email, message} = formData

  const handleChange=(e)=>{
    const {name, value} = e.target
    setFormData({...formData, [name]:value})
  }

  const handleSubmit = () => {
    setLoading(true)

    const contact = {
      _type: 'contact',
      name: name,
      email:email,
      message:message
    }

    console.log(contact)

    client.create(contact)
    .then(()=>{
      setLoading(false)
      setIsFormSubmitted(true)
    }).catch((error)=>{
      setLoading(false)
      setIsFormSubmitted(false)
        alert(error)
    })
  }
  
  return (
    <>
      <h2 className='head-text'>
        Take a break and chat with me
      </h2>
      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href='mailto:jonathanbuntuguh@yahoo.com'>
          jonathanbuntuguh@yahoo.com
          </a>
        </div>

        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a href='tel:+233548255903'>
          +233548255903
          </a>
        </div>
        {!isFormSubmitted ?
      <div className='app__footer-form app__flex'>
      <div className="app__flex">
        <input className='p-text' type={'text'} placeholder="Your name" name='name'
        value={name} onChange={handleChange} />
      </div>

      <div className="app__flex">
        <input className='p-text' type={'email'} placeholder="Your email" name='email'
        value={email} onChange={handleChange} />
      </div>

      <div>
        <textarea 
        className='p-text'
        placeholder='Your message'
        onChange={handleChange}
        value={message}
        name="message"
        />
      </div>
      <button type='button' className='p-text' onClick={handleSubmit}>{loading ? "Sending" : "Send Message"}</button>
    </div>
    :
    <h3 className='head-text'>Thanks for your message</h3>  
      }
      </div>
    </>
  )
}

export default AppWrap(MotionWrap(Footer, 'app__footer'), 'contact', 'app__whitebg')